import type { PiiInfo } from "../api/types";

// Small PII / face-blur chip. Surfaces the FACE BLUR stage result (qc.pii):
//   • "N faces blurred"  when faces were detected (and blurred)
//   • "no faces"         when the stage ran but found none
// Renders nothing when the stage didn't run (pii null/undefined) so it never adds noise.
//
// `compact` trims the wording for the dense queue card; `className` lets callers slot it in.
export default function PiiChip({
  pii,
  compact = false,
  className,
}: {
  pii: PiiInfo | null | undefined;
  compact?: boolean;
  className?: string;
}) {
  if (!pii) return null;

  const faces = pii.faces_detected ?? 0;
  const hasFaces = faces > 0;
  const label = hasFaces
    ? `${faces} ${faces === 1 ? "face" : "faces"} blurred`
    : compact
      ? "no faces"
      : "No faces detected";

  const title = hasFaces
    ? `PII: ${faces} face${faces === 1 ? "" : "s"} detected across ${pii.frames_with_faces} frame${
        pii.frames_with_faces === 1 ? "" : "s"
      }${pii.blurred ? " — blurred" : ""}`
    : "PII: no faces detected in this recording";

  return (
    <span
      className={`pii-chip ${hasFaces ? "has-faces" : "clear"}${className ? ` ${className}` : ""}`}
      title={title}
    >
      <span aria-hidden>{hasFaces ? "◍" : "○"}</span>
      {label}
    </span>
  );
}
